import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import DtoManagementUnitAUP from '../dto/DtoManagementUnitAUP'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import NumberField from '../../../../components/forms/NumberField'
import Input from 'components/forms/Input'
import { hasValue } from 'utils/NumberUtil'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import { DefaultDialogTitle } from 'components/styled/Dialog'

const VolumesManagementUnitDialog = ({
    linkAUPToUpdate,
    openDialog,
    onChange = () => { },
    validUpdate = () => { },
    closeDialog = () => { },
}) => {
    const getValue = (value) => {
        return hasValue(value) ? value : 0
    }

    const getTotal = (link) => {
        return getValue(link.month01) + getValue(link.month02) + getValue(link.month03) + getValue(link.month04) +
        getValue(link.month05) + getValue(link.month06) + getValue(link.month07) + getValue(link.month08) +
        getValue(link.month09) + getValue(link.month10) + getValue(link.month11) + getValue(link.month12)
    }

    return (
        <Dialog
            fullWidth
            maxWidth='lg'
            onClose={closeDialog}
            open={openDialog}
        >
            <DefaultDialogTitle title={i18n.updateVolumesByYears} onClose={closeDialog} />
            <DialogContent>
                <Grid container spacing={1} className='padding-top-1'>
                    <Grid size={6}>
                        <NumberField
                            title={i18n.yearStart}
                            value={linkAUPToUpdate.year}
                            onChange={(value) => onChange({ year: value })}
                        />
                    </Grid>
                    <Grid size={6}>
                        <NumberField
                            title={i18n.yearEnd}
                            value={linkAUPToUpdate.yearEnd}
                            onChange={(value) => onChange({ yearEnd: value })}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid size={6}>
                        <NumberField
                            title={i18n.volume}
                            value={linkAUPToUpdate.aup}
                            onChange={(value) => onChange({ aup: value })}
                        />
                    </Grid>
                    <Grid size={6}>
                        <NumberField
                            title={i18n.volumePrefectural}
                            value={linkAUPToUpdate.aupPrefectural}
                            onChange={(value) => onChange({ aupPrefectural: value })}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid size={6}>
                        <NumberField
                            title={i18n.volumeLowWater}
                            value={linkAUPToUpdate.aupLowWater}
                            onChange={(value) => onChange({ aupLowWater: value })}
                        />
                    </Grid>
                    <Grid size={6}>
                        <NumberField
                            title={i18n.volumeExceptLowWater}
                            value={linkAUPToUpdate.aupExceptLowWater}
                            onChange={(value) => onChange({ aupExceptLowWater: value })}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid size={3}>
                        <NumberField
                            title={i18n.volumeLowWaterSup}
                            value={linkAUPToUpdate.aupLowWaterSup}
                            onChange={(value) => onChange({ aupLowWaterSup: value })}
                        />
                    </Grid>
                    <Grid size={3}>
                        <NumberField
                            title={i18n.volumeLowWaterSout}
                            value={linkAUPToUpdate.aupLowWaterSout}
                            onChange={(value) => onChange({ aupLowWaterSout: value })}
                        />
                    </Grid>
                    <Grid size={3}>
                        <NumberField
                            title={i18n.volumeExceptLowWaterSup}
                            value={linkAUPToUpdate.aupExceptLowWaterSup}
                            onChange={(value) => onChange({ aupExceptLowWaterSup: value })}
                        />
                    </Grid>
                    <Grid size={3}>
                        <NumberField
                            title={i18n.volumeExceptLowWaterSout}
                            value={linkAUPToUpdate.aupExceptLowWaterSout}
                            onChange={(value) => onChange({ aupExceptLowWaterSout: value })}
                        />
                    </Grid>
                </Grid>
                <StyledFieldSet className='margin-1'>
                    <StyledLegend>{i18n.volumeByMonth}</StyledLegend>
                    <Grid container spacing={1}>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.januaryShort}
                                value={linkAUPToUpdate.month01}
                                onChange={value => onChange({ month01: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.februaryShort}
                                value={linkAUPToUpdate.month02}
                                onChange={value => onChange({ month02: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.marchShort}
                                value={linkAUPToUpdate.month03}
                                onChange={value => onChange({ month03: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.aprilShort}
                                value={linkAUPToUpdate.month04}
                                onChange={value => onChange({ month04: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.mayShort}
                                value={linkAUPToUpdate.month05}
                                onChange={value => onChange({ month05: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.juneShort}
                                value={linkAUPToUpdate.month06}
                                onChange={value => onChange({ month06: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.julyShort}
                                value={linkAUPToUpdate.month07}
                                onChange={value => onChange({ month07: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.augustShort}
                                value={linkAUPToUpdate.month08}
                                onChange={value => onChange({ month08: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.septemberShort}
                                value={linkAUPToUpdate.month09}
                                onChange={value => onChange({ month09: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.octoberShort}
                                value={linkAUPToUpdate.month10}
                                onChange={value => onChange({ month10: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.novemberShort}
                                value={linkAUPToUpdate.month11}
                                onChange={value => onChange({ month11: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <NumberField
                                title={i18n.decemberShort}
                                value={linkAUPToUpdate.month12}
                                onChange={value => onChange({ month12: value })}
                                min={0}
                            />
                        </Grid>
                        <Grid size={1}>
                            <Input
                                title={i18n.total}
                                containerClassName='right bold'
                                onChange={value => onChange({ total: value })}
                                value={getTotal(linkAUPToUpdate)}
                                disabled
                            />
                        </Grid>
                    </Grid>
                </StyledFieldSet>
            </DialogContent>
            <DialogActions>
                <Button onClick={validUpdate} variant='contained' color='primary'>
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

VolumesManagementUnitDialog.propTypes = {
    linkAUPToUpdate: PropTypes.instanceOf(DtoManagementUnitAUP),
    openDialog: PropTypes.bool,
    onChange: PropTypes.func,
    validUpdate: PropTypes.func,
    closeDialog: PropTypes.func,
}

export default VolumesManagementUnitDialog